module.exports = __webpack_public_path__ + "img/dzpdf3.a1f6694a.png";